/**
@format
@flow
*/

import React from 'react';
import CardBase from './CardBase';
import type { Props as CardBaseProps } from './CardBase';
import CardProfile from './CardProfile';
import type { Props as CardProfileProps } from './CardProfile';
import CardVideo from './CardVideo';
import type { Props as CardVideoProps } from './CardVideo';
import CardVideoSquare from './CardVideoSquare';
import type { Props as CardVideoSquareProps } from './CardVideoSquare';
import CardVideoSquareGroup from './CardVideoSquareGroup';
import type { Props as CardVideoSquareGroupProps } from './CardVideoSquareGroup';
import CardList from './CardList.';
import type { Props as CardListProps } from './CardList.';
import CardListItemSquircle from './CardListItemSquircle';
import type { Props as CardListItemSquircleProps } from './CardListItemSquircle';
import CardTextStatement from './CardTextStatement';
import type { Props as CardTextStatementProps } from './CardTextStatement';
import CardCompanyDetails from './CardCompanyDetails';
import type { Props as CardCompanyDetailsProps } from './CardCompanyDetails';
import CardVideoPreview from './CardVideoPreview';
import type { Props as CardVideoPreviewProps } from './CardVideoPreview';
import CardSquircle from './CardSquircle';
import type { Props as CardSquircleProps } from './CardSquircle';
import CardTable from './CardTable';
import type { Props as CardTableProps } from './CardTable';
import CardInfo from './CardInfo';
import type { Props as CardInfoProps } from './CardInfo';
import CardNote from './CardNote';
import type { Props as CardNoteProps } from './CardNote';

type ProfileType = {|variant: 'profile', ...CardProfileProps|};
type VideoType = {|variant: 'video', ...CardVideoProps|};
type VideoSquareType = {|variant: 'videoSquare', ...CardVideoSquareProps|};
type VideoPreviewType = {|variant: 'videoPreview', ...CardVideoPreviewProps|};
type VideoSquareGroupType = {|variant: 'videoSquareGroup', ...CardVideoSquareGroupProps|};
type ListType = {|variant: 'list', ...CardListProps |};
type ListItemSquircleType = {|variant: 'listItemSquircle', ...CardListItemSquircleProps|}
type BaseType = {| variant?: 'standard', ...CardBaseProps|};
type SquircleType = {|variant?: 'squircle', ...CardSquircleProps|};
type TableType = {|variant?: 'table', ...CardTableProps|};
type CompanyDetailsType = {|variant?: 'companyDetails', ...CardCompanyDetailsProps|};
type TextStatementType = {|variant?: 'textStatement', ...CardTextStatementProps|};
type InfoType = {|variant?: 'info', ...CardInfoProps|};
type NoteType = {|variant?: 'note', ...CardNoteProps|};
type CardType = ProfileType |
                VideoType |
                VideoSquareType |
                VideoPreviewType |
                VideoSquareGroupType |
                ListType |
                ListItemSquircleType |
                SquircleType |
                TableType |
                CompanyDetailsType |
                TextStatementType |
                InfoType |
                NoteType |
                BaseType;
/**
 * Card orchestrator
 */
const Card: React$ComponentType<CardType> = (props: Object): React$Node => {
  const {
    variant,
    ...rest
  } = props;

  switch (variant) {
  case 'companyDetails':
    return <CardCompanyDetails {...rest} />;
  case 'profile':
    return <CardProfile {...rest} />;
  case 'note':
    return <CardNote {...rest} />;
  case 'video':
    return <CardVideo {...rest} />;
  case 'videoSquare':
    return <CardVideoSquare {...rest} />;
  case 'videoSquareGroup':
    return <CardVideoSquareGroup {...rest} />;
  case 'list':
    return <CardList {...rest} />;
  case 'listItemSquircle':
    return <CardListItemSquircle {...rest} />;
  case 'textStatement':
    return <CardTextStatement {...rest} />;
  case 'videoPreview':
    return <CardVideoPreview {...rest} />;
  case 'squircle':
    return <CardSquircle {...rest} />;
  case 'table':
    return <CardTable {...rest} />;
  case 'info':
    return <CardInfo {...rest} />;
  case 'standard':
  default:
    return <CardBase {...rest} />;
  }
};

export default Card;
